import { getUserSettingsLocale } from '../store/auth.selectors';
import { AuthStore } from '../store/auth.state';
import { DecimalPipe } from '@angular/common';
import { Pipe } from '@angular/core';
import { PplInputIntl } from '@ppl/ui/input';
import { unsubscribe } from '@ppl/utils/subscription.utils';
import type { OnDestroy, PipeTransform } from '@angular/core';
import type { Subscription } from 'rxjs';

@Pipe({
  name: 'pplDecimal',
  standalone: false
})
export class PplDecimalPipe implements PipeTransform, OnDestroy {
  locale: string;
  localeSubscription: Subscription;

  constructor(
    private decimalPipe: DecimalPipe,
    private store: AuthStore,
    private inputIntl: PplInputIntl
  ) {
    this.localeSubscription = this.store.select(getUserSettingsLocale(true)).subscribe(locale => this.locale = locale);
  }

  ngOnDestroy(): void {
    unsubscribe(this.localeSubscription);
  }

  transform(
    value: number,
    digits?: string,
    useThousandSeparator = true
  ) {
    return processThousandSeparator(
      this.decimalPipe.transform(value, digits, this.locale),
      useThousandSeparator,
      this.inputIntl
    );
  }
}

function processThousandSeparator(
  value: string,
  useThousandSeparator: boolean,
  inputIntl: PplInputIntl
) {
  if (!useThousandSeparator && typeof value === 'string') {
    return value.replace(new RegExp(inputIntl.group, 'g'), '');
  } else {
    return value;
  }
}
